import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { MermaidDiagramPage } from './components/MermaidDiagramPage';

export const mermaidDiagramPlugin = createPlugin({
  id: 'mermaid-diagram',
  routes: {
    root: rootRouteRef,
  },
});

// ✅ Isso aqui precisa ser exportado explicitamente
export const MermaidDiagramPageExtension = mermaidDiagramPlugin.provide(
  createRoutableExtension({
    name: 'MermaidDiagramPage',
    component: () => Promise.resolve(MermaidDiagramPage),
    mountPoint: rootRouteRef,
  }),
);
